import { useState } from 'react'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { makeStyles } from 'tss-react/mui'
import { TabConfig } from '../../../shared/model/models'
import { fsColors } from '../../../shared/constants'

const useStyles = makeStyles()((theme) => ({
  tab: {
    height: 10,
    textTransform: 'none',
    border: '1.5px solid',
    borderBottom: '0px solid',
    borderTopLeftRadius: 7,
    borderTopRightRadius: 7,
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.background.paper,
    opacity: 1,
    '&.Mui-selected': {
      opacity: 1,
      backgroundColor: theme.palette.secondary.light,
    },
  },
}))

const FsTabPanel = ({
  tabs,
  onClick,
}: {
  tabs: TabConfig[]
  onClick?: (tabValue: string) => void
}) => {
  const [value, setValue] = useState(tabs[0].value)
  const handleChange = (_: any, newValue: string) => {
    setValue(newValue)
    if (onClick) onClick(newValue)
  }
  const { classes } = useStyles()

  return (
    <Box width="100%">
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="inherit"
          slotProps={{
            indicator: {
              style: { background: fsColors.fsDarkBlue.colors[0] },
            },
          }}
          aria-label="tabs"
        >
          {tabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} className={classes.tab} />
          ))}
        </Tabs>
      </Box>
      {tabs.map(
        (tab) =>
          value === tab.value && (
            <Box key={tab.value} sx={{ padding: 0 }}>
              {tab.component}
            </Box>
          ),
      )}
    </Box>
  )
}

export default FsTabPanel
